let delayer;
export function delayAsync(ms) {
    return new Promise((resolve) => (delayer !== null && delayer !== void 0 ? delayer : setTimeout)(resolve, ms));
}
export function setDelayer(value) {
    delayer = value;
}
